import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { BreadcrumbNav, TabNav, Tab } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';
import { isWorkQueuePath, WORK_QUEUE_PATHS } from '../constants/inboxViews.js';

const PAGE_WRAP = 'flex min-h-0 flex-1 flex-col overflow-hidden bg-surface-base';
/** Horizontal inset is 1.5rem (`px-6`) — same as Admin Studio requests. */
const PAGE_INNER = 'px-6';

/**
 * Work Queues shell: BreadcrumbNav + tabs fixed; outlet fills remaining height.
 * V1: inbox split only. `/event/:eventId` redirects into the split view.
 */
function WorkQueueLayout() {
  const { t } = useTranslation('work-queues-app');
  const navigate = useNavigate();
  const location = useLocation();
  const onActivity = location.pathname.startsWith(WORK_QUEUE_PATHS.activity);
  const onWorkQueue = isWorkQueuePath(location.pathname);

  const breadcrumbItems = [
    { label: t('overview.title'), path: WORK_QUEUE_PATHS.root },
    {
      label: onActivity ? t('tabs.activityLog') : t('tabs.workQueue'),
      // Current crumb — unique key only (BreadcrumbNav keys on `path`; root was duplicated).
      path: onActivity ? WORK_QUEUE_PATHS.activity : `${WORK_QUEUE_PATHS.root}/inbox`,
    },
  ];

  return (
    <main className={PAGE_WRAP}>
      <div className={`${PAGE_INNER} flex min-h-0 flex-1 flex-col overflow-hidden py-3.5`}>
        <BreadcrumbNav size="sm" items={breadcrumbItems} onNavigate={(path) => navigate(path)} />

        <TabNav ariaLabel={t('tabs.ariaLabel')} className="mt-4 shrink-0">
          <Tab selected={onWorkQueue} onClick={() => navigate(WORK_QUEUE_PATHS.root)}>
            {t('tabs.workQueue')}
          </Tab>
          <Tab selected={onActivity} onClick={() => navigate(WORK_QUEUE_PATHS.activity)}>
            {t('tabs.activityLog')}
          </Tab>
        </TabNav>

        <div className="mt-4 flex min-h-0 flex-1 flex-col overflow-hidden">
          <Outlet />
        </div>
      </div>
    </main>
  );
}

export default WorkQueueLayout;
